export default {
	data() {
		return {
			paymentTermsOptions: [
				{text: "Upon receipt",value:0},
				{text: "Net 1 day",value:1},
				{text: "Net 2 days",value:2},
				{text: "Net 3 days",value:3},
				{text: "Net 4 days",value:4},
				{text: "Net 5 days",value:5},
				{text: "Net 6 days",value:6},
				{text: "Net 7 days",value:7},
				{text: "Net 10 days",value:10},
				{text: "Net 14 days",value:14},
				{text: "Net 15 days",value:15},
				{text: "Net 20 days",value:20},
				{text: "Net 30 days",value:30},
				{text: "Net 45 days",value:45},
				{text: "Net 60 days",value:60},
				{text: "Net 90 days",value:90},
				{text: "Net 120 days",value:120},
				{text: "Net 150 days",value:150}
			],
		}
	},
	computed: {
		mutatedInvoices() {
			let vm = this

			return this.$store.invoices.filter(inv => typeof inv != 'undefined').map(inv => {

				if ("Service" in inv && inv.Service && "Customer" in inv.Service) {
					inv.customerName = {
						text: inv.Service.Customer.name,
						link: "/contact/"+inv.Service.Customer.slug+"/details"
					}

					inv.jobTypeNum = {
						text: "#"+inv.Service.job_num,
						link: "/service/"+inv.Service.slug+"/invoice"
					}
				}
				else if ("GroupServices" in inv) {

					if (inv.GroupServices.length > 0) {
						inv.customerName = {
							text: inv.GroupServices[0].Customer.name,
							link: "/contact/"+inv.GroupServices[0].Customer.slug+"/details"
						}
					}

					inv.jobTypeNum = {
						text: "#"+inv.standalone_num,
						link: "/invoice/"+inv.slug+"/details"
					}
				}
				else if ("Job" in inv && inv.Job) {

					inv.customerName = {
						text: "",
						link: ""
					}

					if ("Job" in inv && inv.Job && "Customer" in inv.Job && inv.Job.Customer) {
						inv.customerName = {
							text: inv.Job.Customer.name,
							link: "/contact/"+inv.Job.Customer.slug+"/details"
						}
					}

					let invoiceNum = "#"+inv.Job.job_num+"-"+inv.invoice_num
					if (inv.revision_num > 0)
						invoiceNum += " R"+inv.revision_num

					inv.jobTypeNum = {
						text: invoiceNum,
						link: "/project/"+inv.Job.slug+"/billing/"+inv.slug
					}
				}
				else if (inv.service_id == 0 && (inv.service_contract_id > 0 || inv.is_freeform == 1)) {

					inv.jobTypeNum = {
						text: "#"+inv.standalone_num,
						link: "/invoice/"+inv.slug+"/details"
					}

				}

				if ("manual_invoice_number" in inv && inv.manual_invoice_number) {
					
					let link = ""
					if ("Job" in inv && inv.Job)
						link = "/project/"+inv.Job.slug+"/billing/"+inv.slug
					else if ("Service" in inv && inv.Service)
						link = "/service/"+inv.Service.slug+"/invoice"
					else 
						link = "/invoice/"+inv.slug+"/details"

					inv.jobTypeNum = {
						text: "#"+inv.manual_invoice_number,
						link
					}
				}

				if ("Customer" in inv && inv.Customer) {
					inv.customerName = {
						text: inv.Customer.name,
						link: "/contact/"+inv.Customer.slug+"/details"
					}
				}
				else if ("ServiceContract" in inv && inv.ServiceContract && "Customer" in inv.ServiceContract && inv.ServiceContract.Customer) {
					inv.customerName = {
						text: inv.ServiceContract.Customer.name,
						link: "/contact/"+inv.ServiceContract.Customer.slug+"/details"
					}
				}

				if (!("customerName" in inv)) {
					inv.customerName = {
						text: "No Customer Assigned",
						link: ""
					}
				}

				inv.contractNum = {
					link: "",
					text: ""
				}
				if ("ServiceContract" in inv && inv.ServiceContract) {
					inv.contractNum = {
						text: "#"+inv.ServiceContract.contract_num,
						link: "/service-contract/"+inv.ServiceContract.slug+"/details"
					}
				}

				if (!("jobTypeNum" in inv)) {
					inv.jobTypeNum = {
						text: "N/A",
						link: ""
					}
				}

				if ("is_finalized" in inv)
					inv.finalized = inv.is_finalized

				let amountDue = +inv.grand_total - +inv.amount_paid
				inv.amountDueFormatted = amountDue.toCurrency()

				if (amountDue == 0 && inv.amount_paid > 0)
					inv.status = "Paid"
				else if (inv.finalized == 0)
					inv.status = "Draft"
				else if (inv.finalized == 1 && !inv.last_issued)
					inv.status = "Finalized (unsent)"
				else if (inv.last_issued)
					inv.status = "Sent"
				else if (vm.moment(inv.due_date) < vm.moment())
					inv.status = "Overdue"

				inv.age = ""
				if (inv.issue_date)
					inv.age = vm.moment().diff(inv.issue_date,"days")+"d"

				inv.issueDate = ""
				if (inv.issue_date)
					inv.issueDate = vm.formatDate(inv.issue_date)

				inv.dueDate = ""
				if (inv.due_date)
					inv.dueDate = vm.formatDate(inv.due_date)

				inv.inRevision = false
				inv.isProcessable = true
				if (inv.finalized == 0) {
					inv.inRevision = true
					inv.status = "<i class='fa fa-exclamation'></i> In Revision"
					inv.isProcessable = false
				}
				else if (inv.is_processed == 1)
					inv.isProcessable = false

				inv.seenByCustomer = false

				let taxTotal = +inv.grand_total - +inv.pretax_total
				inv.taxTotalFormatted = taxTotal.toCurrency()

				let amountPaid = +inv.amount_paid
				inv.amountPaidFormatted = amountPaid.toCurrency()

				let grandTotal = +inv.grand_total
				inv.grandTotalFormatted = grandTotal.toCurrency()

				let pretaxTotal = +inv.pretax_total
				inv.pretaxTotalFormatted = pretaxTotal.toCurrency()

				try {
					let log = JSON.parse(inv.seen_log_json)

					if (log.length > 0) {
						inv.seenByCustomer = true
					}
				}
				catch (Ex) {}

				if (inv.qbo_id > 0)
					inv.pushedToQB = "<i class='text-success fa fa-check-circle' title='This invoice has been pushed to QuickBooks'></i>"
				else
					inv.pushedToQB = "<i class='text-danger fa fa-times-circle' title='This invoice has not been pushed to QuickBooks'></i>"

				return inv
			})
		}
	},
	methods: {
		compileDefaultTaxes() {
			let appliedTaxes = {}

			//set default taxes
			try {
				let taxesObjs = JSON.parse(this.$store.company.CompanySetting.taxes_json)

				Object.keys(taxesObjs).forEach(key => {

					if (typeof taxesObjs[key] == 'object' && "isDefault" in taxesObjs[key] && taxesObjs[key].isDefault) {
						appliedTaxes[key] = taxesObjs[key]
					}

				})
			}
			catch (e) {}

			if (appliedTaxes)
				return JSON.stringify(appliedTaxes)

			else
				return ""
		},
		//project invoices
		mutateChangeOrders(changeOrders, excludeLastInvoice) {
			let vm = this

			return changeOrders.map(change => {
				change.item_number = "Q"+vm.$store.project.job_num+"-"+change.quote_num

				let quotePrice = +change.pretax_total

				change.totalValue = quotePrice.toCurrency()

				let totalQtyInvoiced = 0

				//find invoice with highest number
				if (excludeLastInvoice) {
					if (vm.$store.invoices.length > 0) {
						let lastInvoice = vm.$store.invoices[0]
						vm.$store.invoices.forEach(inv => {
							if (+inv.invoice_num > +lastInvoice.invoice_num) 
								lastInvoice = inv
						})

						let matchingInvTask = lastInvoice.JobInvoiceTask.find(invTask => invTask.quote_id == change.id)

						if (matchingInvTask)
							totalQtyInvoiced = +matchingInvTask.qty
					}
				}
				else {
					vm.$store.invoices.forEach(inv => {
						let matchingTask = inv.JobInvoiceTask.find(invTask => invTask.quote_id == change.id)

						if (matchingTask) {
							totalQtyInvoiced = +matchingTask.qty
						}
					})
				}

				change.completedQtyRaw = totalQtyInvoiced
				change.completedQty = totalQtyInvoiced.toFixed(1)

				let completedPercent = 0
				if (change.qty != 0 && totalQtyInvoiced > 0)
					completedPercent = totalQtyInvoiced * 100

				change.completedPercentRaw = completedPercent

				change.completedPercent = vm.renderInlineProgressBar(completedPercent)

				let completedDollars = totalQtyInvoiced * change.pretax_total
				change.completedDollars = completedDollars.toCurrency()

				return change
			})
		},
		//project invoices
		mutateTasks(tasks,excludeLastInvoice) {
			let vm = this

			return tasks.map(task => {
				let totalValue = +task.qty * +task.unit_value

				task.totalValue = totalValue.toCurrency()

				let totalQtyInvoiced = 0

				//find invoice with highest number
				if (excludeLastInvoice) {
					if (vm.$store.invoices.length > 0) {
						let lastInvoice = vm.$store.invoices[0]
						vm.$store.invoices.forEach(inv => {
							if (inv.invoice_num > lastInvoice.invoice_num) 
								lastInvoice = inv
						})
						let matchingTask = lastInvoice.JobInvoiceTask.find(invTask => invTask.task_id == task.id)
						
						if (matchingTask)
							totalQtyInvoiced = +matchingTask.qty
					}
				}
				else {
					vm.$store.invoices.forEach(inv => {
						if (inv && "JobInvoiceTask" in inv && inv.JobInvoiceTask) {

							let matchingTask = inv.JobInvoiceTask.find(invTask => invTask.task_id == task.id)
								if (matchingTask)
									totalQtyInvoiced = +matchingTask.qty
						}
					})
				}

				task.completedQtyRaw = totalQtyInvoiced
				task.completedQty = totalQtyInvoiced.toFixed(1)

				let completedPercent = 0
				if (task.qty != 0 && totalQtyInvoiced > 0)
					completedPercent = totalQtyInvoiced / +task.qty * 100

				task.completedPercentRaw = completedPercent

				task.completedPercent = vm.renderInlineProgressBar(completedPercent)

				let completedDollars = totalQtyInvoiced * task.unit_value
				task.completedDollars = completedDollars.toCurrency()

				return task
			})
		},
		//project invoices
		mutateInvoices(invoices,project) {
			let vm = this

			return invoices.map(invoice => {

				invoice.issueDate = vm.formatDateTimeToLocal(invoice.issue_date,'month-day')
				invoice.invoiceNum = project.job_num + "-"+invoice.invoice_num

				if (invoice.revision_num > 0)
					invoice.invoiceNum += " R"+invoice.revision_num

				invoice.status = "Draft"
				if (invoice.is_finalized == 1)
					invoice.status = "Finalized"
				if (invoice.last_issued)
					invoice.status = "Sent"
				if (invoice.is_paid == 1)
					invoice.status = "Paid"

				let pretaxTotal = +invoice.pretax_total
				invoice.beforeTaxTotal = pretaxTotal.toCurrency()
				invoice.invoiceTotal = +invoice.grand_total
				invoice.invoiceTotal = invoice.invoiceTotal.toCurrency()

				return invoice
			})
		},
		applyPriceAdjustmentAndMarkup(material) {
			let vm = this

			if (!("priceAdjustment" in material)) {
				//go check for default price adjustment setting
				if (vm.clientInvoiceSettings && "default_price_adjustment" in vm.clientInvoiceSettings && vm.clientInvoiceSettings.default_price_adjustment != 0)
					material.priceAdjustment = parseFloat(vm.clientInvoiceSettings.default_price_adjustment)
				else {
					let priceAdjustment = this.getDefaultPriceSetting("Material","price_adjustment")
					material.priceAdjustment = priceAdjustment.toFixed(3)
				}
			}
			else
				material.priceAdjustment = parseFloat(material.priceAdjustment).toFixed(3)

			if (!("markup" in material)) {
				//go check for default markup setting
				if (vm.clientInvoiceSettings && "default_markup" in vm.clientInvoiceSettings && vm.clientInvoiceSettings.default_markup != 0 && vm.clientInvoiceSettings.useMarkup == 1) {
					material.markup = vm.clientInvoiceSettings.default_markup
				}
				else {
					let markup = this.getDefaultPriceSetting("Material","markup")
					material.markup = markup.toFixed(3)
				}
			}
			else
				material.markup = parseFloat(material.markup).toFixed(3)

			return material
		},
		mutateMaterial(material) {
			let vm = this

			if ("parentAssemblies" in material && material.parentAssemblies && material.parentAssemblies.length > 0) {

				material.belongsToAssembly = true

				if (material.parentAssemblies.length == 1) {
					let sourceAssembly = vm.billingDocumentAssemblies.find(as => as.assembly_id == material.parentAssemblies[0].assembly_id)

					if (sourceAssembly)
						material.sourceAssemblyDescription = sourceAssembly.description
				}
				else {
					material.sourceAssemblyDescription = "Multiple Assemblies"
				}
			}
			else {
				material.sourceAssemblyDescription = "Standalone Material"
				material.belongsToAssembly = false
			}

			if (!("price" in material) && "material_price" in material)
				material.price = material.material_price
			else
				material.price = parseFloat(material.price).toFixed(2)

			if (!("qty" in material))
				material.qty = "0.00"
			else
				material.qty = parseFloat(material.qty).toFixed(2)

			material = vm.applyPriceAdjustmentAndMarkup(material)

			if (!("per" in material))
				material.per = 1

			if ("price_adjustment" in material)
				material.priceAdjustment = +material.price_adjustment
			else if ("priceAdjustment" in material)
				material.priceAdjustment = +material.priceAdjustment
			else
				material.priceAdjustment = 1

			if ("markup" in material)
				material.markup = +material.markup
			else
				material.markup = 1

			material.priceAdjustmentFormatted = material.priceAdjustment.toFixed(3)
			material.markupFormatted = material.markup.toFixed(3)

			if  ("manualUnitPrice" in material && material.manualUnitPrice == 1) {
				material.unitTotalRaw = +material.totalUnitPrice
			}
			else
				material.unitTotalRaw = +material.price * +material.priceAdjustment * +material.markup / +material.per

			material.unit_total = material.unitTotalRaw.toFixed(3)
			
			material.totalRaw = material.unitTotalRaw * parseFloat(material.qty)

			material.total = material.totalRaw.toCurrency()

			material.rowClasses = ""

			if (material.belongsToAssembly)
				material.rowClasses = "bg-light"

			return material
		},
		deleteObject(record,resource) {
			let vm = this

			if (!resource)
				resource = "ServiceInvoiceObject"

			return new Promise((resolve,reject) => {

				vm.postData(resource+"/delete",{id: record.id}).then(response => {
					//vm.fetchInvoiceData()
					if (response.success)
						vm.$emit("modelChanged")

					resolve(response)
				})
			})
		},
		confirmRegen() {
			this.$emit("confirmRegen")
		},
		renderDocumentObjectPayload(record,resource) {

			let vm = this

			let fields = JSON.parse(JSON.stringify(record))

			delete fields.id
			delete fields.invoice_id
			delete fields.type
			delete fields.rowClasses
			delete fields.selected

			let postPayload = {
				type: record.type,
				field_values_json: JSON.stringify(fields)
			}

			if ("id" in record)
				postPayload.id = record.id

			if (!resource || resource == "ServiceInvoiceObject") {
				resource = "ServiceInvoiceObject"
				postPayload.invoice_id = record.invoice_id

				delete fields.qty
			}

			if (resource == "JobChangeOrderObject") {
				if ("quote_id" in record)
					postPayload.quote_id = record.quote_id
				else
					postPayload.quote_id = record.invoice_id
			}
			if (resource == 'JobBidComponentObject') {
				postPayload.bid_component_id = record.bid_component_id

				let directFields = ["qty","rate","unit","crew","price_adjustment","markup","object_id"]
				directFields.forEach(field => {
					if (field in fields)
						postPayload[field] = fields[field]
				})

				if ("priceAdjustment" in fields)
					postPayload.price_adjustment = fields.priceAdjustment
			}

			return postPayload
		},
		/**
		* adds or updates a single ServiceInvoiceObject 
		* modal param (object) format: {
				payload: {
					type,
					invoice_id/quote_id/bid_component_id (req one),
					id (optional)
				}
			}
		*/
		saveObject(modal,suppressEmit,resource) {
			if ("visible" in modal)
				modal.visible = false

			if (!resource)
				resource = "ServiceInvoiceObject"

			let vm = this

			let postPayload = vm.renderDocumentObjectPayload(modal.payload,resource)

			return new Promise((resolve,reject) => {
				vm.postData(resource+"/save",postPayload,true).then(response => {
					//vm.fetchInvoiceData()
					if (!suppressEmit) 
						vm.$emit("modelChanged")
					
					resolve(response)
				})
			})

		},
		/* deletes existing ServiceInvoiceObjects, and replaces them with the list of objects provided */
		overwriteObjects(existingObjectsOrIds,newObjects,apiResource) {
			let vm = this

			let promises = []
			existingObjectsOrIds.forEach(item => {
				if (typeof item == 'object')
					promises.push(vm.postData(apiResource+"/delete",{id: item.id}))
				else
					promises.push(vm.postData(apiResource+"/delete",{id: item}))
			})

			return new Promise((resolve,reject) => {
				Promise.all(promises).then(responses => {
					let payload = {
						records: JSON.stringify(newObjects)
					}

					vm.postData(apiResource+"/save-batch",payload).then(response =>{
						vm.$emit("modelChanged")
						resolve(response)
					})
				})
			})
		},
		fetchProjectTasks(spinner) {
			let vm = this

			let params = {
				filters: [
					["job_id", this.$store.project.id]
				]
			}

			if (spinner)
				vm.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON("JobTask/get",params).then(response => {
					if (spinner)
						vm.spinner(false)

					if (response.success)
						vm.tasks = response.data

					resolve(response)
				})
			})
		},
		fetchProjectInvoices(spinner,include) {
			let vm = this

			let params = {
				filters: [
					["job_id",this.$store.project.id],
					["is_active_version",1]
				]
			}

			if (include)
				params.include = include

			if (spinner)
				vm.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON("JobInvoice/get",params,true).then(response => {
					if (spinner)
						vm.spinner(false)

					if (response.success)
						vm.$store.invoices = response.data

					resolve(response)
				})
			})
		},
		fetchProjectChangeOrders(spinner,include) {
			let vm = this

			let params = {
				filters: [
					["job_id",this.$store.project.id],
					["quote_status","Accepted"],
					["is_finalized",1]
				]
			}

			if (include)
				params.include = include

			if (spinner)
				vm.spinner(true)

			return new Promise((resolve,reject) => {

				vm.getJSON("JobChangeQuote/get",params,true).then(response => {
					if (response.success)
						vm.changeOrders = response.data

					if (spinner)
						vm.spinner(false)

					resolve(response)
				})	

			})
		},
	}
}